/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum SoftwareRequirement {
  None = "none",
  Teams = "teams",
  Everyone = "everyone",
}

export function instanceOfSoftwareRequirement(value: any): boolean {
  for (const key in SoftwareRequirement) {
    if (Object.prototype.hasOwnProperty.call(SoftwareRequirement, key)) {
      if (
        SoftwareRequirement[key as keyof typeof SoftwareRequirement] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function SoftwareRequirementFromJSON(json: any): SoftwareRequirement {
  return SoftwareRequirementFromJSONTyped(json, false);
}

export function SoftwareRequirementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SoftwareRequirement {
  return json as SoftwareRequirement;
}

export function SoftwareRequirementToJSON(
  value?: SoftwareRequirement | null,
): any {
  return value as any;
}

export function SoftwareRequirementToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): SoftwareRequirement {
  return value as SoftwareRequirement;
}
